import { initHeader } from "./modules/header.js";
import { gtm } from "./modules/gtm.js";
import { initAccomodationSlider } from "./modules/accomodation-slider.js";
import { initItinerarySlider } from "./modules/itinerary-slider.js";
import { initHomeHeroSlider } from "./modules/home-hero-slider.js";
import { initAccomodationContactForm } from "./modules/accomodation-contact-form.js";
import { initPrenotaOraButton } from "./modules/prenota-ora-button.js";
import { initOffersSlider } from "./modules/offers-slider.js";
import { initOffersModal } from "./modules/offers-modal.js";
import { initNearItinerariesSlider } from "./modules/near-itineraries-slider.js";
// import { initAccomodationServizi   } from "./modules/accomodation-servizi.js";

document.addEventListener( "DOMContentLoaded", () => {
    initHeader();
    initAccomodationSlider();
	initItinerarySlider();
	initHomeHeroSlider();
	initAccomodationContactForm();
	initPrenotaOraButton();
	initOffersSlider();
	initOffersModal();
	initNearItinerariesSlider();
	// initAccomodationServizi();

	// GTM: static itinerary cards (homepage slider)
	document.addEventListener( 'click', ( e ) => {
		const card = e.target.closest( '.itinerary-card[data-gtm-itinerary-id]' );
		if ( card ) {
			gtm.clickItineraryCard( {
				itinerary_id         : card.dataset.gtmItineraryId,
				itinerary_name       : card.dataset.gtmItineraryName || '',
				itinerary_region     : card.dataset.gtmItineraryRegion || '',
				itinerary_difficulty : parseInt( card.dataset.gtmItineraryDifficulty || '0', 10 ),
			} );
		}
	} );

	// GTM: static accommodation cards
	document.addEventListener( 'click', ( e ) => {
		const btn = e.target.closest( '.button[data-gtm-acc-id]' );
		if ( btn ) {
			gtm.clickAccommodationCard( {
				accommodation_id   : btn.dataset.gtmAccId,
				accommodation_name : btn.dataset.gtmAccName || '',
			} );
		}
	} );
});
